export const warningMessages = {
  validateCondition: "You must have a condition",
  validateDate: "Start date must be less than or equal end date",
  validateRequireField: "You must type all require field",
  level: "You must level all require field"
};